import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router';
import { connect } from 'react-redux';
import { IonButton, IonIcon, IonCard, IonCardContent, IonCol, IonContent, IonGrid, IonInput, IonItem, IonList, IonPage, IonRouterLink, IonRow, IonTitle, IonCardHeader, IonCardTitle, IonImg, IonCardSubtitle, IonText } from '@ionic/react';
import { arrowBackOutline, eye, eyeOff } from 'ionicons/icons';

import { SessionDefaultStateI } from '../../store/session/SessionReducer';
import { setStyleMode } from '../../utils/StyleUtils';

import ApiRequestor from '../../api_access/ApiRequestor';
import Footer from '../Footer/Footer';

import './LoginOverview.css';
import Modal from '../Modal/Modal';

interface Props extends StateTypes { }

const ResetPass: React.FC<Props> = (props): JSX.Element => {

  const [formData, setFormData] = useState({
    username: '',
    code: '',
    pass: '',
    passRep: ''
  })
  const [errors, setErrors] = useState({
    username: '',
    code: '',
    pass: '',
    passRep: ''
  })
  const {username, code, pass, passRep} = formData
  const [showModal, setShowModal] = useState(false)
  const [textModal, setTextModal] = useState("")
  const [showPass, setShowPass] = useState<boolean>(false)
  const [showPassRep, setShowPassRep] = useState<boolean>(false)
  const [redirectData, setRedirectData] = useState(false)
  const regularExpressionPass = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;

  useEffect(() => {
    setStyleMode()
  }, [])

  useEffect(() => {
    const enterKey = (e: any) => {
      if (e.key === "Enter") {
        setShowModal(false)
      }
    }
    const modalResetPass = document.getElementById("modal-reset-pass")
    modalResetPass?.addEventListener('keypress', enterKey)
  }, [showModal])

  const getDataForm = (e: any) => {
    setFormData({
        ...formData,
        [e.target.name]: e.detail.value!
    })
}

  if (props.session.loggedIn) {
    return <Redirect to="/page/kpigroup/services" />
  }

  const handlePasswordVisibility = () => {
    setShowPass(showPass ? false : true)
  }

  const handlePasswordRepVisibility = () => {
    setShowPassRep(showPassRep ? false : true)
  }

  const validationForm = () =>{
    const isEmpty = (value:any) => !value.trim();

    const errors = {
      username: isEmpty(formData.username)
      ?'El nombre de usuario no debe estar vacío'
      :'',
      code: isEmpty(formData.code)
      ?'El código no debe estar vacío'
      : formData.code.length >= 7
      ? 'El código debe tener 6 caracteres'
      :'',
      pass: isEmpty(formData.pass)
      ?'La contraseña no debe estar vacía'
      :!regularExpressionPass.test(formData.pass) || formData.pass.length >= 25
      ? 'Entre 8 y 24 caracteres, al menos 1 mayúscula, 1 minúsculas, 1 número y 1 carácter especial (#?!@$%^&*-)'
      :'',
      passRep: isEmpty(formData.passRep)
      ?'No debe estar vacía.'
      : formData.pass !== formData.passRep
      ?'Las contraseñas no coinciden'
      :''
    };

    setErrors(errors as any);
    const hastErrors = Object.values(errors).some(error => error !== '');

    return hastErrors;
  }

  const onSubmit = async () => {

    validationForm();
    let valid = validationForm();

    if (!valid) {

      let data: any = { 
        body: { 
          username: formData.username, 
          code: formData.code, 
          password: formData.pass 
        } }

      const response: any = await ApiRequestor.authRequestToUser('/auth/reset-pass', "POST", data, "USER")

      if (!response.data.message) {
        setTextModal("Se ha modificado correctamente su contraseña")
        setShowModal(true)
      } else {
        if (response.data.message.includes("Username/client id combination not found.")) {
          setTextModal("No se encontro un usuario registrado con ese nombre")
          setShowModal(true)
        } else {
          if (response.data.message.includes("Invalid code provided, please request a code again.")) {
            setTextModal("Código de confirmación incorrecto. Por favor intente nuevamente.")
            setShowModal(true)
          } else {
            if (response.data.message.includes("Attempt limit exceeded, please try after some time.")) {
              setTextModal("No se pudo resetear la contraseña, se alcanzó el número máximo de intentos. Por favor intente nuevamente en otro momento.")
              setShowModal(true)
            } else {
              setTextModal(response.data.message)
              setShowModal(true)
            }
          }
        }
      }
    } else {
      validationForm()
    }
  }

  const onSuccess = () => {
    if (textModal.includes("Se ha modificado correctamente su contraseña")) {
      setShowModal(false)
      localStorage.removeItem("username")
      setRedirectData(true)
    }
    setShowModal(false)
  }

  if (redirectData === true) {
    return <Redirect to="/page/login" />
  }

  const returnModalChildren = (): JSX.Element => {
    return (
      <>
        <IonText>
          <p className="ion-padding ion-text-center login-modal-text"> {textModal}</p>
        </IonText>
        <IonRow className="ion-text-center ion-padding-bottom">
          <IonCol size-lg="12" size-md="12">
            <IonButton className="login-button" fill="outline" size="small" onClick={() => { onSuccess() }}>Aceptar</IonButton>
          </IonCol>
        </IonRow>
      </>
    )
  }


  return (
    <IonPage >
      <IonContent className="ion-text-center">
        <IonGrid className="ion-no-padding">
          <IonRow>
            <IonCol size="12" className="colLogin colLoginForgot ion-padding-bottom">
              <IonRouterLink href="/page/forgot-pass">
                <IonIcon icon={arrowBackOutline} className="login-back-arrow" />
              </IonRouterLink>
              <IonTitle className="ion-padding ion-text-center login-title">
                <div className="ion-text-wrap ion-padding-bottom"> MONITOREO DE SERVICIOS</div>
              </IonTitle>
            </IonCol>
          </IonRow>
          <IonRow className="ion-justify-content-center login-row">
            <IonCard className="cardLogin ion-text-center">
              <IonCardHeader className="">
                <IonCardTitle className="login-card-title">RECUPERACIÓN DE CONTRASEÑA</IonCardTitle>
              </IonCardHeader>
              <IonCardContent>
                <IonList className="">
                  <IonRow className="ion-justify-content-center">
                    <IonCol size-xl="8" size-lg="8" size-md="8" size-sm="12" size-xs="12">
                      <IonCardSubtitle className="ion-text-start ion-margin-start">Nombre de usuario</IonCardSubtitle>
                      <IonItem className="login-item" lines="none">
                        <IonInput className="inputLogin"
                          type='text'
                          name="username"
                          placeholder="Nombre de usuario"
                          required
                          value={username}
                          onIonChange={(e) => {
                            getDataForm(e)
                          }}
                          />
                      </IonItem>
                      <IonText>
                        <p className={errors.username ? "login-valid-text" : "ion-hide"}>{errors.username}</p>
                      </IonText>
                    </IonCol>
                  </IonRow>
                  <IonRow className="ion-justify-content-center">
                    <IonCol size-xl="8" size-lg="8" size-md="8" size-sm="12" size-xs="12">
                      <IonCardSubtitle className="ion-text-start ion-margin-start">Código de confirmación</IonCardSubtitle>
                      <IonItem className="login-item" lines="none">
                        <IonInput className="inputLogin"
                          type='number'
                          name="code"
                          placeholder="XXXXXX"
                          required
                          value={code}
                          onIonChange={(e) => {
                            getDataForm(e)
                          }} />
                      </IonItem>
                      <IonText>
                        <p className={errors.code ? "login-valid-text" : "ion-hide"}> {errors.code}</p>
                      </IonText>
                    </IonCol>
                  </IonRow>
                  <IonRow className="ion-justify-content-center">
                    <IonCol size-xl="8" size-lg="8" size-md="8" size-sm="12" size-xs="12">
                      <IonCardSubtitle className="ion-text-start ion-margin-start">Nueva contraseña</IonCardSubtitle>
                      <IonItem className="login-item" lines="none">
                        <IonInput className="inputLogin"
                          type={showPass ? 'text' : 'password'}
                          name="pass"
                          placeholder="Mínimo 8 caracteres"
                          required
                          value={pass}
                          onIonChange={(e) => getDataForm(e)}/>
                        <IonIcon icon={showPass ? eye : eyeOff} onClick={handlePasswordVisibility} className="loginEye" />
                      </IonItem>
                      <IonText>
                        <p className={errors.pass ? "login-valid-text" : "ion-hide"}>{errors.pass}</p>
                      </IonText>
                    </IonCol>
                  </IonRow>
                  <IonRow className="ion-justify-content-center">
                    <IonCol size-xl="8" size-lg="8" size-md="8" size-sm="12" size-xs="12">
                      <IonCardSubtitle className="ion-text-start ion-margin-start">Repetir nueva contraseña</IonCardSubtitle>
                      <IonItem className="login-item" lines="none">
                        <IonInput className="inputLogin"
                          type={showPassRep ? 'text' : 'password'}
                          name="passRep"
                          placeholder="Mínimo 8 caracteres"
                          required
                          value={passRep}
                          onIonChange={(e) => getDataForm(e)}/>
                        <IonIcon icon={showPassRep ? eye : eyeOff} onClick={handlePasswordRepVisibility} className="loginEye" />
                      </IonItem>
                      <IonText>
                        <p className={errors.passRep ? "login-valid-text" : "ion-hide"}> {errors.passRep}</p>
                      </IonText>
                    </IonCol>
                  </IonRow>
                  <IonRow>
                    <IonCol size="12" className="ion-padding">
                      <IonButton className="ion-margin-top login-button" fill="outline" onClick={onSubmit}>Validar</IonButton>
                    </IonCol>
                  </IonRow>
                </IonList>
              </IonCardContent>
            </IonCard>
          </IonRow>

          <Modal
            modalChildren={{
              id: "modal-reset-pass",
              styles: "login-modal",
              isOpen: showModal,
              onDidDismiss: () => setShowModal(false),
              children: returnModalChildren(),
            }}

          />

        </IonGrid>
        <Footer />
      </IonContent>
    </IonPage>
  );
};

//Redux state and actions dispatchers

interface StateTypes {
  session: SessionDefaultStateI
}

const mapStateToProps = (state: StateTypes) => {
  return {
    session: state.session
  };
};

export default connect(mapStateToProps)(ResetPass);